<template>
  <div class="home">
    <van-nav-bar
      title="轨迹信息"
      left-text="返回"
      left-arrow
      right-text="回放"
      @click-left="$router.go('-1')"
      @click-right="handleReplay"
    />
    <van-field
      readonly
      clickable
      name="datetimePicker"
      :value="time_begin"
      label="开始时间"
      placeholder="开始时间"
      right-icon="arrow"
      @click="showTimeBegin = true"
    />
    <van-field
      readonly
      clickable
      name="datetimePicker"
      :value="time_end"
      label="结束时间"
      placeholder="结束时间"
      right-icon="arrow"
      @click="showTimeEnd = true"
    />
    <van-popup v-model="showTimeBegin" position="bottom">
      <van-datetime-picker
        v-model="pickerBeginTime"
        type="datetime"
        title="开始时间"
        @confirm="changeBeginTime"
        @cancel="showTimeBegin = false"
      />
    </van-popup>
    <van-popup v-model="showTimeEnd" position="bottom">
      <van-datetime-picker
        v-model="pickerEndTime"
        type="datetime"
        title="结束时间"
        @confirm="changeEndTime"
        @cancel="showTimeEnd = false"
      />
    </van-popup>
    <div id="container" class="container"></div>
  </div>
</template>

<script>
import { NavBar, Button, NoticeBar, Field, Popup, DatetimePicker, Toast } from 'vant'
export default {
  data() {
    return {
      timer: null,
      studentInfo: {},
      showTimeBegin: false,
      showTimeEnd: false,
      showPicker: false,
      time_begin: '',
      time_end: '',
      pickerBeginTime: new Date(),
      pickerEndTime: new Date(),
      map: null,
      // pointList: [
      //   {
      //     lng: 116.397428,
      //     lat: 39.90923
      //   },
      //   {
      //     lng: 115.397428,
      //     lat: 38.90923
      //   },
      //   {
      //     lng: 126.397428,
      //     lat: 39.90923
      //   },
      //   {
      //     lng: 116.397428,
      //     lat: 39.90923
      //   }
      // ],
      a_mark: null, //图标点
      marker: [
        [116.478935, 39.997761],
        [116.478939, 39.997825],
        [116.478912, 39.998549],
        [116.478912, 39.998549],
        [116.478998, 39.998555],
        [116.478998, 39.998555],
        [116.479282, 39.99856],
        [116.479658, 39.998528],
        [116.480151, 39.998453],
        [116.480784, 39.998302],
        [116.480784, 39.998302],
        [116.481149, 39.998184],
        [116.481573, 39.997997],
        [116.481863, 39.997846],
        [116.482072, 39.997718],
        [116.482362, 39.997718],
        [116.483633, 39.998935],
        [116.48367, 39.998968],
        [116.484648, 39.999861]
      ],
      lineArr: [
        [116.478935, 39.997761],
        // [116.478939, 39.997825],
        [116.478912, 39.998549],
        // [116.478912, 39.998549],
        [116.478998, 39.998555],
        // [116.478998, 39.998555],
        [116.479282, 39.99856],
        [116.479658, 39.998528],
        [116.480151, 39.998453],
        [116.480784, 39.998302],
        [116.480784, 39.998302],
        [116.481149, 39.998184],
        [116.481573, 39.997997],
        [116.481863, 39.997846],
        [116.482072, 39.997718],
        [116.482362, 39.997718],
        [116.483633, 39.998935],
        [116.48367, 39.998968],
        [116.484648, 39.999861]
      ],
      studentSrc: require('../../assets/images/student-small.png')
    }
  },
  mounted() {
    this.getStudnetInfo()
    this.map = new window.AMap.Map('container', {
      resizeEnable: true,
      zoom: 17
    })
  },
  methods: {
    startRun() {
      //开始绘制轨迹
      var x = this.pointList[0].lng
      var y = this.pointList[0].lat
      this.completeEventHandler(x, y)
      this.marker.moveAlong(this.lineArr, 80) //开始轨迹回放
    },

    handleAddPosition() {
      console.log(this.range_marker, '2111')
      console.log(this.polygonArr, '222')
    },

    changeBeginTime(val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      var hour = val.getHours()
      var minute = val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`
      }
      this.time_begin = `${year}-${month}-${day} ${hour}:${minute}`
      this.showTimeBegin = false
    },

    changeEndTime(val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      var hour = val.getHours()
      var minute = val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`
      }
      this.time_end = `${year}-${month}-${day} ${hour}:${minute}`
      this.showTimeEnd = false
    },

    // 获取学生信息
    getStudnetInfo() {
      var sinfo = localStorage.getItem("currentChild");
      //alert(sinfo);
      this.studentInfo=JSON.parse(sinfo);
    },

    // 回放
    handleReplay() {
      var beginTime = new Date(this.time_begin.replace(/-/g, '/'))
      var endTime = new Date(this.time_end.replace(/-/g, '/'))
      var time = Math.abs((beginTime - endTime) / (1000 * 60 * 60 * 24))

      if (time > 7) {
        Toast('查询时间不能大于7天')
        return
      }

      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在获取中'
      })
      this.marker = []
      this.lineArr = []
      clearInterval(this.timer)
      this.$http
        .json_post(this.$api.studentcard.gettrackdata, {
          Deviceid: this.studentInfo.Deviceid,
          St: this.time_begin + ':00',
          Et: this.time_end + ':59'
        })
        .then(data => {
          if (data.code == 0) {
            toast.clear()
            this.map.clearMap()
            var res = data.data
            if (res.Code == 1) return Toast('此时间段暂无轨迹~')
            if (res.Data.length <= 1) return Toast('此时间段暂无轨迹~')
            var arr = new Array()
            for (var i = 0; i < res.Data.length; i++) {
              var a = new Array()
              a[0] = res.Data[i].Lon
              a[1] = res.Data[i].Lat
              arr[i] = a
            }
            this.marker = null
            this.lineArr = null
            this.marker = arr
            this.lineArr = arr
            this.marker = new AMap.Marker({
              map: this.map,
              position: [arr[0][0], arr[0][1]],
              icon: this.studentSrc,
              offset: new AMap.Pixel(-15, -18),
              autoRotation: true,
              angle: -90
            })

            // 绘制轨迹
            var polyline = new AMap.Polyline({
              map: this.map,
              path: this.lineArr,
              showDir: true,
              strokeColor: '#28F', //线颜色
              strokeWeight: 6 //线宽
            })
            var passedPolyline = new AMap.Polyline({
              map: this.map,
              strokeColor: '#AF5', //线颜色
              strokeWeight: 6 //线宽
            })
            var i = 0,
              path = []
            this.timer = setInterval(() => {
              if (i === this.lineArr.length - 1) {
                clearInterval(this.timer)
              }
              this.marker.moveTo(this.lineArr[i++], 120000)
            }, 1000)
            this.marker.on('moving', function(e) {
              Array.prototype.push.apply(path, e.passedPath)
              passedPolyline.setPath(path)
            })
            this.map.setFitView()
          }
        })
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-button': Button,
    'van-notice-bar': NoticeBar,
    'van-field': Field,
    'van-popup': Popup,
    'van-datetime-picker': DatetimePicker,
    'van-toast': Toast
  }
}
</script>

<style lang="scss" scoped>
.home,
#container {
  width: 100%;
  height: calc(100vh - 90px);
}
.operat {
  position: fixed;
  bottom: 40px;
  z-index: 99999;
  display: flex;
  width: 100%;
  justify-content: center;
  i {
    width: 50px;
    height: 50px;
    font-size: 18px;
    margin-top: 15px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    background: #40e0d0; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    &.icon-dingwei1 {
      font-size: 22px;
    }
  }
}
</style>
